module.exports = __webpack_public_path__ + "static/media/netherlands.14d268ce.png";